import { FEATURE_FLAG_KEYS } from '@alpha-core/alpha-utils/lib/feature-flags/feature-flag.constants';
import { FeatureFlagsService } from '@neutrinos/ngx-feature-flags';
declare global {
    var FF: {
        service: FeatureFlagsService;
        keys: typeof FEATURE_FLAG_KEYS;
    };
}

export function InjectFFIntoWindow(service: FeatureFlagsService) {
    window.FF = {
        service,
        keys: FEATURE_FLAG_KEYS,
    };
}
